export default "__VITE_ASSET__CIb37McC__"